import React from 'react';
import './../ErrorPage/errorPage.scss';

export default class NotAvailable extends React.Component {

  render() {
    return (
      <div>
        <div className="alert-box">
          <div className="container">
            <div className="row justify-content-md-center">
              <div className="col col-lg-10 col-md-11 col-sm-12">
                <div className="pt-2">
                  <div className="alert alert-dismissible alert-danger">
                    <div className="row justify-content-start no-wrap">
                      <div className="left-box"><span
                        className="clapply-icon exclamation-mark">&#9432;</span></div>
                      <div className="right-box d-flex align-items-center text-danger">
                        <p className="alert-body mb-0">The requested URL is no longer
                                                    available. </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
